const toStringOrUndefined = (value: unknown) =>
  typeof value === 'string' && value.trim().length > 0 ? value : undefined;

export const resolveJwtToken = (jwt: unknown) => {
  if (typeof jwt === 'string') {
    return toStringOrUndefined(jwt);
  }

  if (jwt && typeof jwt === 'object' && 'token' in jwt) {
    return toStringOrUndefined((jwt as { token?: unknown }).token);
  }

  return undefined;
};
